import React, { useState, useEffect } from 'react';
import { Fragment } from 'react';
import Box from '../Box';
import axios from 'axios';

const AdminContactType = (props) => {

    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);
    const [directOptions, setDirectOptions] = useState([{val:true, desc:"SI"},{val:false, desc:"NO"}]);
    const [error, setError] = useState(null);

    useEffect(() => {
    }, []);

    const handleInputChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value })
    }

    const adminContactType = () => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        if (props.method === 'NEW') {
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/contactTypes`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: formData
            };

            //add dependent data
            options.data.idCompany = props.dependentData.idCompany;

            axios(options).then(response => { 
                if (response.status === 200 && response.data.error === undefined) {
                    props.methodToRefreshList();
                }
            });
        }

        if (props.method === 'EDIT') {
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/contactType`,
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: formData
            };

            options.data.contactTypeId = props.dependentData.id;

            axios(options).then(response => {
                if (response.status === 200 && response.data.error === null) {
                    props.methodToRefreshList();
                }
            });
        }


        if (props.method === 'DELETE') {
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/contactType`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: formData
            };

            options.data.contactTypeId = props.dependentData.id;

            axios(options).then(response => {
                if (response.status === 200 && response.data.error === null) {
                    props.methodToRefreshList();
                }
            }).catch(function (error) {
                if (error.response.status === 500 && error.response.data != null) {
                    setError('No es posible eliminar el tipo de contacto seleccionado ya que hay datos vinculados a este.');
                }
            });
        }
    }

    return (
        <Fragment>
            {props.method === 'NEW' ? (
                <Fragment>
                    <h3>Nuevo tipo de contacto</h3>
                    <p>Ingrese la descripción del tipo de contacto y haga click<br />en "Añadir".</p>
                </Fragment>
            ) : props.method === 'EDIT' ? (
                <Fragment>
                    <h3>Modificar tipo de contacto</h3>
                    <p>Modifique la descripción del tipo de contacto y haga click<br />en "Modificar".</p>
                </Fragment>
            ) : props.method === 'DELETE' ? (
                <Fragment>
                    <h3>Eliminar tipo de contacto</h3>
                    <p className="center">¿Está seguro de eliminar el tipo de contacto <b>{props.dependentData.desc}</b>?</p>
                </Fragment>
            ) : null}

            <div className="flexRow">
                {props.method === 'NEW' ? (
                    <div className="flexCol">
                        <Box type="text" name="contactTypeDesc" label="Descripción tipo de contacto" className="x3" placeholder="Ingrese nombre ..." onChange={handleInputChange}></Box>
                        <Box type="text" name="contactTypeCode" label="Código" className="x1" placeholder="Ingrese codigo ..." onChange={handleInputChange}></Box>
                        <Box type="select" name="direct" label="Es contacto directo?" className="x2" placeholder="Seleccione ..." options={directOptions} onChange={handleInputChange} required></Box>
                        <button className="collapsed default" type="button" onClick={() => adminContactType()}>Añadir</button>
                    </div>
                ) : props.method === 'EDIT' ? (
                    <div className="flexCol">
                        <Box type="text" name="contactTypeDesc" label="Descripción tipo de contacto" value={props.dependentData.desc} className="x3" placeholder="Ingrese nombre ..." onChange={handleInputChange} ></Box>
                        <Box type="text" name="contactTypeCode" label="Código tipo de contacto" value={props.dependentData.code} className="x1" placeholder="Ingrese codigo ..." onChange={handleInputChange}></Box>
                        <Box type="select" name="direct" label="Es contacto directo?" className="x2" placeholder="Seleccione ..." options={directOptions} onChange={handleInputChange} required></Box>
                        <button className="collapsed default" type="button" onClick={() => adminContactType()}>Modificar</button>
                    </div>
                ) : props.method === 'DELETE' ? (
                    <div className="flexCol fullWidth center">
                        <button className='aloneInRow normalHeight' type="button" onClick={() => adminContactType()}>Si, eliminar</button>
                    </div>
                ) : null}
            </div>
            {error ? (<div className="errorWrapper">{error}</div>) : null}
        </Fragment>
    );

}

export default AdminContactType;